<div class="form-group">
  <label [for]="inputId" *ngIf="!suppressLabel" [ngClass]="{ 'font-weight-bold': labelBold }">
    {{ translateTag | translate: translateParams }}
    <i *ngIf="tooltip" class="fal fa-question-circle" ngbTooltip="{{ tooltip | translate }}"></i>
    <span *ngIf="footnote" class="ml-1">*</span>
  </label>
  <textarea
    type="text"
    [class]="extraInputClass"
    [ngClass]="renderStatic ? 'form-control-plaintext' : 'form-control'"
    [readonly]="renderStatic"
    [id]="inputId"
    [name]="inputId"
    [required]="required"
    [disabled]="disabled"
    [placeholder]="placeholder | translate"
    [rows]="rowsNumber"
    [maxlength]="maxlength"
    [ngStyle]="{ resize: blockResize ? 'none' : undefined }"
    [(ngModel)]="value"
  >
  </textarea>
</div>
